import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const GuideCard = ({ 
  title = "Guide Title",
  subtitle = "A brief description of what this guide covers.",
  category = "Skincare",
  link = "#",
  imageUrl = null
}) => {
  return (
    <Link 
      to={link}
      data-testid="guide-card"
      className="group block bg-white border border-[#E5E5E5] overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-[#C88D74]/30"
    >
      {/* Image Section */}
      <div className="aspect-[16/9] bg-[#F2EBE3] overflow-hidden relative">
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={title}
            className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#6B7280]">
            <span className="font-accent italic text-lg">Guide Image</span>
          </div>
        )}
        {/* Category Tag Overlay */}
        <span className="absolute top-4 left-4 px-3 py-1 bg-[#3A4D39] text-white text-xs font-medium tracking-wider uppercase">
          {category}
        </span>
      </div>
      
      {/* Content Section */}
      <div className="p-5 md:p-6">
        <h3 className="font-heading text-xl md:text-2xl font-semibold text-[#1C1C1C] mb-2 leading-tight group-hover:text-[#3A4D39] transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-[#374151] text-sm md:text-base mb-4 leading-relaxed line-clamp-2">
          {subtitle}
        </p>
        
        <span className="inline-flex items-center gap-2 text-[#3A4D39] text-sm font-medium tracking-wide uppercase">
          Read Guide
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};

export default GuideCard;
